import React from 'react';
import {translatedName} from 'app/utils/translations_helper';
import {SimpleArtifactImage} from 'app/components/my_profile/artifacts/image';
import {shopItemPrice, currencyItem} from 'app/utils/ShopItemPriceFormat';
import ShopItemMeta from 'app/components/shop/lootboxes/ShopItemMeta';
import LootboxDetailsActions from './LootboxDetailsActions';
import ShopLootboxInterface from 'app/interfaces/shop/ShopLootboxInterface';

interface Props {
    lootbox: ShopLootboxInterface
    currency: string
    opening: boolean
    openingInProgress: boolean
    owned: boolean
    disabled: boolean
    buyNow: boolean
    afterBuy: () => void
    hideQuickOpen: boolean
    onOpen: () => void
    onQuickOpen: () => void
}

const LootboxDetailsHeader = ({
    lootbox,
    currency,
    opening,
    openingInProgress,
    owned,
    disabled,
    buyNow,
    afterBuy,
    hideQuickOpen,
    onOpen,
    onQuickOpen
}: Props): React.ReactElement => {
    const {recipe, game_name} = lootbox;

    return <div className={`lootbox-detail__header${opening ? ' lootbox-detail__header--opening' : ''}`}>
        <div className="lootbox-detail__header-inner">
            <div className="lootbox-detail__preview">
                <SimpleArtifactImage artifact={recipe}/>
            </div>
            <div className="lootbox-detail__info">
                <div className="lootbox-detail__text">
                    <div className="lootbox-detail__heading">
                        <h2 className="lootbox-detail__title">{translatedName(recipe)}</h2>
                        <ShopItemMeta
                            loot={recipe?.loot}
                            maxCalculatedPrice={recipe?.max_calculated_price}
                            gameName={game_name}
                        />
                    </div>
                    <div className="lootbox-detail__price">
                        {shopItemPrice({
                            cost_money: Number(lootbox.cost_money),
                            cost_points: Number(lootbox.cost_points),
                            currency: currencyItem(currency)
                        })}
                    </div>
                </div>
                <LootboxDetailsActions
                    lootbox={lootbox}
                    currency={currency}
                    owned={owned}
                    openingInProgress={openingInProgress}
                    disabled={disabled}
                    buyNow={buyNow}
                    afterBuy={afterBuy}
                    hideQuickOpen={hideQuickOpen}
                    onOpen={onOpen}
                    onQuickOpen={onQuickOpen}
                />
            </div>
        </div>
    </div>;
};

export default LootboxDetailsHeader;
